import * as DateF from 'date-fns'

import { CHART_PRICE_PERIOD_MS_MAP } from '@blade/blockchain-types'
import { Duration } from '@blade/std-lib'

import type { ChartPricePeriod } from '@blade/blockchain-types'

/**
 * Floors a timestamp to the nearest ms
 * For 5 minutes: 15:34 -> 15:00
 */
export const floorChartPricePeriod = (
  timestamp: Date,
  period: ChartPricePeriod,
) => {
  const trunc = CHART_PRICE_PERIOD_MS_MAP[period]
  const milliseconds = new Date(timestamp).getTime()
  return new Date(Math.floor(milliseconds / trunc) * trunc)
}

/**
 * Returns the timestamp in seconds
 */
export const getTimeInSeconds = (timestamp: Date | string) => {
  return Math.floor(new Date(timestamp).getTime() / 1000)
}

export const toDateFDuration = (
  duration: Duration.Duration,
): DateF.Duration => {
  return DateF.intervalToDuration({
    start: 0,
    end: Duration.toMillis(duration),
  })
}
